// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2QFwe","icon":"icon--2dCth","input":"input--p9w8T","clear":"clear--b3EPd","active":"active--3M0G3","clear-icon":"clear-icon--1c9UL"};